// material-ui
import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

// ==============================|| DRAWER HEADER - STYLED ||============================== //
type OpenProp = {
    open?: boolean
};
const DrawerHeaderStyled = styled(Box, { shouldForwardProp: (prop) => prop !== 'open' })<OpenProp>(({ theme, open }) => ({
    ...theme.mixins.toolbar,
    display: 'flex',
    alignItems: 'center',
    color:'white',
    justifyContent: open==true ? 'flex-start' : 'center',
    paddingLeft: theme.spacing(open ? 3 : 0)
}));

export default DrawerHeaderStyled;
